import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {SocialShareButtons} from '@communityshare/ui-shared';
import useIsEventShareable from '@/features/share-event/hooks/useIsEventShareable';
import useEventShareActions from '@/features/share-event/hooks/useEventShareActions';
import hasBeenShared from '@/features/share-event/utils/hasBeenShared';

EventSocialShare.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      title: PropTypes.string,
      published: PropTypes.bool,
      shared: PropTypes.bool
    })
  }).isRequired
};

// Only shown for shareable events that have been shared already (the API's
// `shared` flag on the event).
export default function EventSocialShare(props) {
  const {event} = props;
  const {t} = useTranslation();
  const isShareable = useIsEventShareable(event);
  const actions = useEventShareActions(event);

  if (!hasBeenShared(isShareable, event.data)) {
    return null;
  }

  return (
    <SocialShareButtons
      {...actions}
      copiedLinkLabel={t('controls.Copied')}
      copyLinkLabel={t('controls.Copy link')}
    />
  );
}
